import request from '@/utils/request'

let projectApi = {
  /*项目列表*/
  projectList(data, errorback) {
    return request._post('/shop/plus.project.Project/index', data, errorback);
  },
  /*添加项目*/
  addProject(data, errorback) {
    return request._post('/shop/plus.project.Project/add', data, errorback);
  },
  getProjectData(data, errorback) {
    return request._get('/shop/plus.project.Project/add', data, errorback);
  },
  /*获取项目数据*/
  getProject(data, errorback) {
    return request._get('/shop/plus.project.Project/edit', data, errorback);
  },
  /*保存项目*/
  editProject(data, errorback) {
    return request._post('/shop/plus.project.Project/edit', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.project.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.project.Setting/getSetting', data, errorback);
  },
  /*删除项目*/
  deleteProject(data, errorback) {
    return request._post('/shop/plus.project.Project/delete', data, errorback);
  },
  
  
}
export default projectApi;



// WEBPACK FOOTER //
// ./src/api/project.js